import { render } from "./PlayerScoutReportView.vue?vue&type=template&id=0814235a"
import script from "./PlayerScoutReportView.vue?vue&type=script&lang=js"
export * from "./PlayerScoutReportView.vue?vue&type=script&lang=js"

import "./PlayerScoutReportView.vue?vue&type=style&index=0&id=0814235a&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__